export class SideMenu {
  link: string;
  icon: string;
  libelle: string;
  isRouteAllowed: boolean;
  isNotificationAllowed?: boolean;

  constructor(
    link: string,
    libelle: string,
    isRouteAllowed: boolean,
    icon: string,
    roles?: string[],
    isNotificationAllowed = false
  ) {
    this.link = link;
    this.icon = icon;
    this.libelle = libelle;
    this.isRouteAllowed = isRouteAllowed;
    this.isNotificationAllowed = isNotificationAllowed;
  }
}
